import {Stack} from 'shells/layout/stack/stack';
import {LoadingText} from 'shells/loading-placeholder/loading-text';

import styles from './sidebar-thread-list-item.module.css';

export function SidebarThreadListItemLoading() {
    return (
        <div className={styles['sidebar-thread-list-item']}>
            <Stack spacing={8}>
                <LoadingText width={100} />
                <LoadingText width={120} />
                <LoadingText width={140} />
                <Stack isHorizontal={true} justifyContent='space-between'>
                    <LoadingText width={80} />
                    <LoadingText width={50} />
                </Stack>
            </Stack>
        </div>
    );
}
